import { _ } from "../polyglot/polyglot.js";
import { informDialog } from "./dialogs/dialogs.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import optionsBag from "../../models/options/optionsBag.js";
import ReportDisclaimerWidget from "./ReportDisclaimerWidget.js";

/**
 * Render a report disclaimer inside a popup modal dialog.
 *
 * @param {company} spec.company - .
 * @param {agency} spec.agency - .
 * @param {period} spec.period - .
 */
export default class ReportDisclaimerPopupWidget extends Widget {
	constructor({ company, agency, period }) {
		super(...arguments);

		this._company = company;
		this._agency = agency;
		this._period = period;

		/**
		 * Id of the local storage key for the disclaimer popup displayed upon first
		 * user access to Accounting.
		 */
		this._disclaimerPopupStorageId = "disclaimer-popup";

		this._reportDisclaimerWidget = new ReportDisclaimerWidget({
			company: this._company,
			agency: this._agency,
			period: this._period,
		});

		this._dialog = informDialog({
			header: _("Disclaimer"),
			body: this._reportDisclaimerWidget,
			okLabel: _("I understand"),
			callback: this._hidePopup.bind(this),
			contentCssClass: "resizable-modal-content",
		});
	}

	show() {
		if (!this._shouldBeDisplayed()) {
			return;
		}
		this._dialog.show();
	}

	_hidePopup() {
		this._dialog.hide();
		window.localStorage.setItem(this._disclaimerPopupStorageId, true);
	}

	_shouldBeDisplayed() {
		return (
			optionsBag.fromId("disclaimer").isActive() &&
			!window.localStorage.getItem(this._disclaimerPopupStorageId)
		);
	}
}
